class RandomOutline {

	constructor(el, params) {

		// param vars

		this.$el = $(el);
		this.params = params;

		//

		this._width = !this.params || isNaN(parseFloat(this.params.width)) ? 60 : parseFloat(this.params.width);
		this._height = !this.params || isNaN(parseFloat(this.params.height)) ? 60 : parseFloat(this.params.height);

		let attrShiftX = this.$el.attr('data-shift-x');
		this._shiftX = typeof(attrShiftX) !== 'undefined' && !isNaN(parseFloat(attrShiftX)) ? parseFloat(attrShiftX) : 1;

		let attrShiftY = this.$el.attr('data-shift-y');
		this._shiftY = typeof(attrShiftY) !== 'undefined' && !isNaN(parseFloat(attrShiftY)) ? parseFloat(attrShiftY) : 1;

		//

		this.redraw();

		//

		$(() => {
			this._onDomReady();
		});
	}

	// private methods

	_onDomReady(){
		this._addListeners();
	}

	_addListeners(){

		this.$el.on('redraw', this._onRedraw.bind(this));

		window.vent.on('domUpdate', this._onDomUpdate, this);
	}

	_onRedraw(){
		this.redraw();
	}

	_onDomUpdate(e, obj){
		if(obj && obj.$scanContainer[0].contains(this.$el[0])){
			this.redraw();
		}
	}

	// public methods

	redraw(){

		// random rect

		let $outlines = this.$el.find('svg');

		$outlines.each((index, value) => {

			let $value = $(value);
			let d = 'M' + (this.width - 1) + ',1L' + (this.width - 1) + ',' + (this.height - 1) + 'L1,' + (this.height - 1) + 'L1,1 M' + (this.width + 0.5) + ',-0.5L-0.5,-0.5L-0.5,' + (this.height + 0.5) + 'L' + (this.width + 0.5) + ',' + (this.height + 0.5) + 'L' + (this.width + 0.5) + ',-0.5';
			let dSets = d.split(' ');
			let dShapeInner = {};
			let startPos = 0;
			let curSet = dSets[0];
			let coordsIndex = 0;
			let lineWidth = 2;

			// inner rect

			for(let i=0; i<curSet.length; i++){

				let char = curSet.charAt(i);

				if((isNaN(parseInt(char)) && String('-.,').indexOf(char) === -1) || i >= curSet.length-1){

					let coordsGroup = i >= curSet.length-1 ? curSet.substring(startPos+1) : curSet.substring(startPos+1, i);

					if(coordsGroup.indexOf(',') >= 0){

						let coords = {x:0, y:0}
						let coordsSplit = coordsGroup.split(',');

						for(let k=0; k<coordsSplit.length; k++){

							let num = parseFloat(coordsSplit[k]);

							let shiftXAmount = this._isSmall ? this._shiftX/2 : this._shiftX;
							let shiftX = Math.round(shiftXAmount - Math.random() * shiftXAmount * 2);

							let shiftYAmount = this._isSmall ? this._shiftY/2 : this._shiftY;
							let shiftY = Math.round(shiftYAmount - Math.random() * shiftYAmount * 2);

							if(k === 0){
								coords.x = num + shiftX;
							}
							else {
								coords.y = num + shiftY;
							}
						}

						switch(coordsIndex){
							case 0: dShapeInner.tr = coords; break;
							case 1: dShapeInner.br = coords; break;
							case 2: dShapeInner.bl = coords; break;
							case 3: dShapeInner.tl = coords; break;
						}

						coordsIndex++;
					}

					startPos = i;
				}
			}

			// config outer shape

			let oShape = {};
			oShape.tr = {x:dShapeInner.tr.x + lineWidth, y:dShapeInner.tr.y - lineWidth};
			oShape.br = {x:dShapeInner.br.x + lineWidth, y:dShapeInner.br.y + lineWidth};
			oShape.bl = {x:dShapeInner.bl.x - lineWidth, y:dShapeInner.bl.y + lineWidth};
			oShape.tl = {x:dShapeInner.tl.x - lineWidth, y:dShapeInner.tl.y - lineWidth};

			// rebuild svg

			let newD = '';

			newD += 'M' + dShapeInner.tr.x + ',' + dShapeInner.tr.y + 'L' + dShapeInner.br.x + ',' + dShapeInner.br.y + 'L' + dShapeInner.bl.x + ',' + dShapeInner.bl.y + 'L' + dShapeInner.tl.x + ',' + dShapeInner.tl.y;
			newD += ' ';
			newD += 'M' + oShape.tr.x + ',' + oShape.tr.y + 'L' + oShape.tl.x + ',' + oShape.tl.y + 'L' + oShape.bl.x + ',' + oShape.bl.y + 'L' + oShape.br.x + ',' + oShape.br.y + 'L' + oShape.tr.x + ',' + oShape.tr.y + 'z';

			$value.find('path').attr('d', newD);
		});

		//
	}

	// getters / setters

	get width(){ return this._width; }
	set width(value){
		this.width = value;
		this.redraw();
	}

	get height(){ return this._height; }
	set height(value){
		this.height = value;
		this.redraw();
	}
}

module.exports = RandomOutline;
